// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AppSidebar — custom (no MUI). Fixed under the header, company purple. */

.app-sidebar {
  position: fixed;
  top: var(--app-header-height, 56px);
  bottom: 0;
  left: 0;
  width: var(--app-sidebar-width, 248px);
  z-index: 1050;
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: linear-gradient(135deg, #4510b0 65%, #5616ea 100%);
  font-family: "DM Sans", sans-serif;
  transition: transform 0.25s ease;
}

/* ── Scrollable nav ────────────────────────────────────────────────── */
.app-sidebar-nav {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 12px 10px 8px;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.45) transparent;
}

.app-sidebar-nav::-webkit-scrollbar {
  width: 8px;
}
.app-sidebar-nav::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.35);
  border: 2px solid transparent;
  border-radius: 999px;
  background-clip: padding-box;
}
.app-sidebar-nav::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.6);
  background-clip: padding-box;
}

.app-nav-group {
  margin-bottom: 2px;
}

/* ── Option-set swap: stagger in on appear, fade out on disappear ───────
   Two option sets share this region (single "Agents" entry ↔ full agent
   nav). AppSidebar.js fades the outgoing set out as a block (\`is-exiting\`),
   then mounts the incoming set under a fresh key so each row unfolds into
   place one by one, offset by its \`--nav-stagger\` index. */

/* Outgoing set — fade away together, and stop catching clicks mid-fade. */
.app-nav-view.is-exiting {
  animation: app-nav-view-out 0.17s ease both;
  pointer-events: none;
}
@keyframes app-nav-view-out {
  from { opacity: 1; transform: translateY(0); }
  to   { opacity: 0; transform: translateY(-6px); }
}

/* Incoming rows — unfold downward into place, staggered by position. */
.app-nav-cascade {
  transform-origin: top center;
  animation: app-nav-item-in 0.26s cubic-bezier(0.4, 0, 0.2, 1) both;
  animation-delay: calc(var(--nav-stagger, 0) * 38ms);
}
@keyframes app-nav-item-in {
  from { opacity: 0; transform: translateY(-9px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  .app-nav-view.is-exiting,
  .app-nav-cascade {
    animation: none;
  }
}

/* ── "All Agents" back link (shown when an agent is selected) ───────── */
.app-nav-back {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 7px 12px;
  margin: 0 0 8px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: rgba(255, 255, 255, 0.7);
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.app-nav-back:hover {
  background-color: var(--sidebar-hover-bg);
  color: #ffffff;
}

.app-nav-back-icon {
  width: 20px;
  font-size: 13px;
  text-align: center;
  flex-shrink: 0;
  transition: transform 0.15s ease;
}

.app-nav-back:hover .app-nav-back-icon {
  transform: translateX(-2px);
}

/* ── Top-level item (leaf or group header) ─────────────────────────── */
.app-nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 9px 12px;
  margin: 2px 0;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: rgba(255, 255, 255, 0.92);
  font-family: inherit;
  font-size: 14.5px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.app-nav-item:hover {
  background-color: var(--sidebar-hover-bg);
}

.app-nav-item.selected {
  background-color: #ffffff;
  color: #5616ea;
  font-weight: 600;
}

/* A collapsed group whose selected sub-item is hidden: tint the header with
   the hover colour so the user can still see which group owns the active
   route (the white pill only shows while the group is expanded). */
.app-nav-item.app-nav-parent.has-active-child {
  background-color: var(--sidebar-hover-bg);
}

.app-nav-icon {
  width: 20px;
  font-size: 16px;
  text-align: center;
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.85);
}

.app-nav-item.selected .app-nav-icon {
  color: #5616ea;
}

.app-nav-label {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.app-nav-chev {
  flex: 0 0 auto;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  transition: transform 0.25s ease;
}
.app-nav-chev.open {
  transform: rotate(180deg);
}

/* ── Collapsible sub-list (0fr → 1fr height animation, no JS) ───────── */
.app-nav-subwrap {
  display: grid;
  grid-template-rows: 0fr;
  /* Clip the absolutely-positioned active indicators (pill + line) and the
     sub-list padding while collapsed, so nothing bleeds out between the
     collapsed group header and the next item. */
  overflow: hidden;
  transition: grid-template-rows 0.25s ease;
}
.app-nav-subwrap.open {
  grid-template-rows: 1fr;
}
.app-nav-sub {
  position: relative;
  overflow: hidden;
}

/* Faint full-height guide line, centered under the parent icon. */
.app-nav-guide {
  position: absolute;
  left: 20px;
  top: 4px;
  bottom: 8px;
  width: 2px;
  border-radius: 1px;
  background: rgba(255, 255, 255, 0.18);
  z-index: 0;
}

/* Sliding white pill behind the active row (provides the selected
   background + border). Height/offsets keyed to the 36px row. */
.app-nav-active-bg {
  position: absolute;
  left: 28px;
  right: 8px;
  top: 2px;
  height: 32px;
  border-radius: 9px;
  background: #ffffff;
  border: 1px solid rgba(40, 18, 110, 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  z-index: 1;
  pointer-events: none;
  transition: transform 0.22s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Sliding bright segment sitting exactly on the guide line (same width
   and x), as tall as the active pill, square ends. */
.app-nav-active-line {
  position: absolute;
  left: 20px;
  top: 2px;
  width: 2px;
  height: 32px;
  border-radius: 0;
  background: #ffffff;
  z-index: 2;
  pointer-events: none;
  transition: transform 0.22s cubic-bezier(0.4, 0, 0.2, 1);
}

.app-nav-subitem {
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;
  height: 36px;
  padding: 0 12px 0 36px;
  box-sizing: border-box;
  border: none;
  border-radius: 9px;
  background: transparent;
  color: rgba(255, 255, 255, 0.82);
  font-family: inherit;
  font-size: 13.5px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: color 0.15s ease;
}

/* Hover fill for a non-active sub-item — same footprint as the sliding
   active pill (left/right/top/height/radius below mirror .app-nav-active-bg)
   filled with the shared hover colour, so it matches the parent rows and the
   header selectors. Sits behind the icon/label via z-index: -1. */
.app-nav-subitem::before {
  content: "";
  position: absolute;
  left: 28px;
  right: 8px;
  top: 2px;
  height: 32px;
  border-radius: 9px;
  background-color: var(--sidebar-hover-bg);
  opacity: 0;
  transition: opacity 0.15s ease;
  pointer-events: none;
  z-index: -1;
}

.app-nav-subitem:hover:not(.selected) {
  color: #ffffff;
}
.app-nav-subitem:hover:not(.selected)::before {
  opacity: 1;
}

.app-nav-subitem.selected {
  color: #2c1769;
  font-weight: 600;
}

.app-nav-subicon {
  width: 18px;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.7);
  transition: color 0.15s ease;
}
.app-nav-subitem.selected .app-nav-subicon {
  color: #5616ea;
}

/* Single-colour brand artwork (the black Wix wordmark) sitting in a nav row.
   The sidebar is dark purple and the hover fill only lifts it 7%, so the mark is
   knocked out to white for both of those states; \`selected\` swaps the row to a
   white pill, where the original artwork is the readable one. brightness(0)
   first flattens any anti-aliasing to black so invert() yields a clean white
   rather than a washed grey. Multi-colour logos (Drive, OneDrive, Notion,
   Shopify) must NOT carry this class: their brand colours read fine on both. */
.app-nav-subicon .nav-logo-mono {
  filter: brightness(0) invert(1);
  transition: filter 0.15s ease;
}
.app-nav-subitem.selected .app-nav-subicon .nav-logo-mono {
  filter: none;
}

/* Becoming active, the row turns purple at once. A colour transition runs on the main thread: while
   the next page was still building it stalled, but the white pill (a transform, animated off the main
   thread) had already arrived, so icon and label stayed white on white for up to a second. */
.app-nav-subitem.selected,
.app-nav-subitem.selected .app-nav-subicon,
.app-nav-subitem.selected .app-nav-subicon .nav-logo-mono {
  transition: none;
}

/* Unread-leads badge (Activity group header + Leads leaf). Default sits on the
   purple sidebar: white pill, purple number. */
.app-nav-badge {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 19px;
  height: 19px;
  padding: 0 6px;
  border-radius: 999px;
  background: #ffffff;
  color: #5616ea;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1;
}
/* The selected leaf sits on a white pill, so invert the badge (purple fill,
   white number) to keep it readable and consistent with the unselected look. */
.app-nav-subitem.selected .app-nav-badge {
  background: #5616ea;
  color: #ffffff;
}

/* ── Bottom block ──────────────────────────────────────────────────── */
.app-sidebar-bottom {
  flex: 0 0 auto;
  padding: 8px 10px 14px;
}

/* "+ New Agent" — primary action on the account-level nav. White pill on the
   purple sidebar so it reads as the main CTA, echoing the selected-row pill. */
.app-sidebar-new-agent {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 12px;
  border: none;
  border-radius: 10px;
  background: #ffffff;
  color: #5616ea;
  font-family: "DM Sans", sans-serif;
  font-size: 15.5px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.05s ease;
}
.app-sidebar-new-agent:hover {
  background: #f1ecfe;
}
.app-sidebar-new-agent:active {
  transform: translateY(1px);
}

.app-sidebar-footer-links {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 22px 12px 0;
}
.app-sidebar-footer-links a {
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
  text-decoration: none;
}
.app-sidebar-footer-links a:hover {
  color: #fff;
  text-decoration: underline;
}

/* ── Responsive: slide-over on mobile ──────────────────────────────── */
@media (max-width: 768px) {
  .app-sidebar {
    transform: translateX(-100%);
    /* No shadow while collapsed: the panel sits at translateX(-100%) with its
       right edge on the screen's left edge, so a right-cast shadow bleeds onto
       the page. Only show it once the drawer is open. */
    box-shadow: none;
  }
  .app-sidebar.app-sidebar--open {
    transform: translateX(0);
    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.35);
  }
}

/* ── Mobile-only docked controls (workspace + bot selectors + Test Agent) ──
   On phones these move out of the header and sit at the top of the sidebar,
   above a hairline divider and the nav. Only rendered when isMobile, so no
   media query is needed here. */
.app-sidebar-mobile-top {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 12px 14px;
  /* Divider underneath the docked controls (replaces a separate hairline div). */
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
/* Full-width translucent pills: white-on-translucent, borderless, space-between. */
.app-sidebar-mobile-top .org-switcher,
.app-sidebar-mobile-top .bot-selector {
  width: 100%;
  margin: 0;
  padding-right: 0;
}
.app-sidebar-mobile-top .org-switcher-trigger,
.app-sidebar-mobile-top .bot-selector-trigger {
  width: 100%;
  margin: 0;
  justify-content: space-between;
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 8px;
}
.app-sidebar-mobile-top .org-switcher-trigger:hover,
.app-sidebar-mobile-top .org-switcher-trigger:focus-within,
.app-sidebar-mobile-top .org-switcher-trigger.open,
.app-sidebar-mobile-top .bot-selector-trigger:hover,
.app-sidebar-mobile-top .bot-selector-trigger:focus-within,
.app-sidebar-mobile-top .bot-selector-trigger.open {
  background-color: rgba(255, 255, 255, 0.16);
  border: none;
}
.app-sidebar-mobile-top .org-switcher-menu,
.app-sidebar-mobile-top .bot-selector-menu {
  left: 0;
  right: 0;
}
/* Compact single line: drop the "Current Workspace" / "Current agent" roles,
   small leading icon, 13px bold name, small chevron. */
.app-sidebar-mobile-top .org-switcher-role,
.app-sidebar-mobile-top .bot-selector-role {
  display: none;
}
.app-sidebar-mobile-top .org-switcher-icon,
.app-sidebar-mobile-top .bot-selector-icon {
  width: auto;
  height: auto;
  font-size: 15px;
  flex: 0 0 auto;
}
.app-sidebar-mobile-top .org-switcher-label,
.app-sidebar-mobile-top .bot-selector-label {
  gap: 8px;
  padding: 7px 4px 7px 10px;
}
.app-sidebar-mobile-top .org-switcher-name,
.app-sidebar-mobile-top .bot-selector-name {
  font-size: 13px;
  font-weight: 600;
}
.app-sidebar-mobile-top .org-switcher-chev-btn,
.app-sidebar-mobile-top .bot-selector-chev-btn {
  padding: 7px 10px 7px 4px;
}
.app-sidebar-mobile-top .org-switcher-chev,
.app-sidebar-mobile-top .bot-selector-chev {
  font-size: 18px;
}
/* Test Agent: full-width white CTA under the switchers. Padding + font match
   the selector pills (7px label padding, 13px text; the button's 1px border
   makes up the extra 1px) so all three sit at the same height. */
.app-sidebar-mobile-top .app-header-test-btn {
  width: 100%;
  justify-content: center;
  gap: 8px;
  padding: 6px 12px;
  font-size: 13px;
}
.app-sidebar-mobile-top .app-header-test-btn span {
  display: inline-flex;
}
`, "",{"version":3,"sources":["webpack://./src/components/AppSidebar.css"],"names":[],"mappings":"AAAA,0EAA0E;;AAE1E;EACE,eAAe;EACf,mCAAmC;EACnC,SAAS;EACT,OAAO;EACP,sCAAsC;EACtC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,8DAA8D;EAC9D,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA,yEAAyE;AACzE;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,UAAU;AACZ;AACA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;2DAI2D;;AAE3D,0EAA0E;AAC1E;EACE,2CAA2C;EAC3C,oBAAoB;AACtB;AACA;EACE,OAAO,UAAU,EAAE,wBAAwB,EAAE;EAC7C,OAAO,UAAU,EAAE,2BAA2B,EAAE;AAClD;;AAEA,uEAAuE;AACvE;EACE,4BAA4B;EAC5B,kEAAkE;EAClE,mDAAmD;AACrD;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;mEAEmE;AACnE;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,uBAAuB;EACvB;;gDAE8C;EAC9C,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,qCAAqC;EACrC,UAAU;AACZ;;AAEA;gEACgE;AAChE;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,yCAAyC;EACzC,UAAU;EACV,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;qDACqD;AACrD;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;;;kEAGkE;AAClE;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,UAAU;EACV,8BAA8B;EAC9B,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;;AAEA;;;;;;+EAM+E;AAC/E;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;;AAEA;;6FAE6F;AAC7F;;;EAGE,gBAAgB;AAClB;;AAEA;+CAC+C;AAC/C;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;+EAC+E;AAC/E;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;+EAC+E;AAC/E;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uDAAuD;AACzD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA,yEAAyE;AACzE;EACE;IACE,4BAA4B;IAC5B;;wDAEoD;IACpD,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,0CAA0C;EAC5C;AACF;;AAEA;;;gCAGgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,+EAA+E;EAC/E,iDAAiD;AACnD;AACA,mFAAmF;AACnF;;EAEE,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,SAAS;EACT,8BAA8B;EAC9B,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;AACpB;AACA;;;;;;EAME,2CAA2C;EAC3C,YAAY;AACd;AACA;;EAEE,OAAO;EACP,QAAQ;AACV;AACA;uDACuD;AACvD;;EAEE,aAAa;AACf;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,QAAQ;EACR,yBAAyB;AAC3B;AACA;;EAEE,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,eAAe;AACjB;AACA;;iEAEiE;AACjE;EACE,WAAW;EACX,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB","sourcesContent":["/* AppSidebar — custom (no MUI). Fixed under the header, company purple. */\r\n\r\n.app-sidebar {\r\n  position: fixed;\r\n  top: var(--app-header-height, 56px);\r\n  bottom: 0;\r\n  left: 0;\r\n  width: var(--app-sidebar-width, 248px);\r\n  z-index: 1050;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  background: linear-gradient(135deg, #4510b0 65%, #5616ea 100%);\r\n  font-family: \"DM Sans\", sans-serif;\r\n  transition: transform 0.25s ease;\r\n}\r\n\r\n/* ── Scrollable nav ────────────────────────────────────────────────── */\r\n.app-sidebar-nav {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  padding: 12px 10px 8px;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgba(255, 255, 255, 0.45) transparent;\r\n}\r\n\r\n.app-sidebar-nav::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n.app-sidebar-nav::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.35);\r\n  border: 2px solid transparent;\r\n  border-radius: 999px;\r\n  background-clip: padding-box;\r\n}\r\n.app-sidebar-nav::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(255, 255, 255, 0.6);\r\n  background-clip: padding-box;\r\n}\r\n\r\n.app-nav-group {\r\n  margin-bottom: 2px;\r\n}\r\n\r\n/* ── Option-set swap: stagger in on appear, fade out on disappear ───────\r\n   Two option sets share this region (single \"Agents\" entry ↔ full agent\r\n   nav). AppSidebar.js fades the outgoing set out as a block (`is-exiting`),\r\n   then mounts the incoming set under a fresh key so each row unfolds into\r\n   place one by one, offset by its `--nav-stagger` index. */\r\n\r\n/* Outgoing set — fade away together, and stop catching clicks mid-fade. */\r\n.app-nav-view.is-exiting {\r\n  animation: app-nav-view-out 0.17s ease both;\r\n  pointer-events: none;\r\n}\r\n@keyframes app-nav-view-out {\r\n  from { opacity: 1; transform: translateY(0); }\r\n  to   { opacity: 0; transform: translateY(-6px); }\r\n}\r\n\r\n/* Incoming rows — unfold downward into place, staggered by position. */\r\n.app-nav-cascade {\r\n  transform-origin: top center;\r\n  animation: app-nav-item-in 0.26s cubic-bezier(0.4, 0, 0.2, 1) both;\r\n  animation-delay: calc(var(--nav-stagger, 0) * 38ms);\r\n}\r\n@keyframes app-nav-item-in {\r\n  from { opacity: 0; transform: translateY(-9px); }\r\n  to   { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .app-nav-view.is-exiting,\r\n  .app-nav-cascade {\r\n    animation: none;\r\n  }\r\n}\r\n\r\n/* ── \"All Agents\" back link (shown when an agent is selected) ───────── */\r\n.app-nav-back {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  width: 100%;\r\n  padding: 7px 12px;\r\n  margin: 0 0 8px;\r\n  border: none;\r\n  border-radius: 10px;\r\n  background: transparent;\r\n  color: rgba(255, 255, 255, 0.7);\r\n  font-family: inherit;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.01em;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s ease, color 0.15s ease;\r\n}\r\n\r\n.app-nav-back:hover {\r\n  background-color: var(--sidebar-hover-bg);\r\n  color: #ffffff;\r\n}\r\n\r\n.app-nav-back-icon {\r\n  width: 20px;\r\n  font-size: 13px;\r\n  text-align: center;\r\n  flex-shrink: 0;\r\n  transition: transform 0.15s ease;\r\n}\r\n\r\n.app-nav-back:hover .app-nav-back-icon {\r\n  transform: translateX(-2px);\r\n}\r\n\r\n/* ── Top-level item (leaf or group header) ─────────────────────────── */\r\n.app-nav-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  width: 100%;\r\n  padding: 9px 12px;\r\n  margin: 2px 0;\r\n  border: none;\r\n  border-radius: 10px;\r\n  background: transparent;\r\n  color: rgba(255, 255, 255, 0.92);\r\n  font-family: inherit;\r\n  font-size: 14.5px;\r\n  font-weight: 500;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s ease, color 0.15s ease;\r\n}\r\n\r\n.app-nav-item:hover {\r\n  background-color: var(--sidebar-hover-bg);\r\n}\r\n\r\n.app-nav-item.selected {\r\n  background-color: #ffffff;\r\n  color: #5616ea;\r\n  font-weight: 600;\r\n}\r\n\r\n/* A collapsed group whose selected sub-item is hidden: tint the header with\r\n   the hover colour so the user can still see which group owns the active\r\n   route (the white pill only shows while the group is expanded). */\r\n.app-nav-item.app-nav-parent.has-active-child {\r\n  background-color: var(--sidebar-hover-bg);\r\n}\r\n\r\n.app-nav-icon {\r\n  width: 20px;\r\n  font-size: 16px;\r\n  text-align: center;\r\n  flex-shrink: 0;\r\n  color: rgba(255, 255, 255, 0.85);\r\n}\r\n\r\n.app-nav-item.selected .app-nav-icon {\r\n  color: #5616ea;\r\n}\r\n\r\n.app-nav-label {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.app-nav-chev {\r\n  flex: 0 0 auto;\r\n  font-size: 12px;\r\n  color: rgba(255, 255, 255, 0.7);\r\n  transition: transform 0.25s ease;\r\n}\r\n.app-nav-chev.open {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n/* ── Collapsible sub-list (0fr → 1fr height animation, no JS) ───────── */\r\n.app-nav-subwrap {\r\n  display: grid;\r\n  grid-template-rows: 0fr;\r\n  /* Clip the absolutely-positioned active indicators (pill + line) and the\r\n     sub-list padding while collapsed, so nothing bleeds out between the\r\n     collapsed group header and the next item. */\r\n  overflow: hidden;\r\n  transition: grid-template-rows 0.25s ease;\r\n}\r\n.app-nav-subwrap.open {\r\n  grid-template-rows: 1fr;\r\n}\r\n.app-nav-sub {\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Faint full-height guide line, centered under the parent icon. */\r\n.app-nav-guide {\r\n  position: absolute;\r\n  left: 20px;\r\n  top: 4px;\r\n  bottom: 8px;\r\n  width: 2px;\r\n  border-radius: 1px;\r\n  background: rgba(255, 255, 255, 0.18);\r\n  z-index: 0;\r\n}\r\n\r\n/* Sliding white pill behind the active row (provides the selected\r\n   background + border). Height/offsets keyed to the 36px row. */\r\n.app-nav-active-bg {\r\n  position: absolute;\r\n  left: 28px;\r\n  right: 8px;\r\n  top: 2px;\r\n  height: 32px;\r\n  border-radius: 9px;\r\n  background: #ffffff;\r\n  border: 1px solid rgba(40, 18, 110, 0.12);\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\r\n  z-index: 1;\r\n  pointer-events: none;\r\n  transition: transform 0.22s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n/* Sliding bright segment sitting exactly on the guide line (same width\r\n   and x), as tall as the active pill, square ends. */\r\n.app-nav-active-line {\r\n  position: absolute;\r\n  left: 20px;\r\n  top: 2px;\r\n  width: 2px;\r\n  height: 32px;\r\n  border-radius: 0;\r\n  background: #ffffff;\r\n  z-index: 2;\r\n  pointer-events: none;\r\n  transition: transform 0.22s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.app-nav-subitem {\r\n  position: relative;\r\n  z-index: 3;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 11px;\r\n  width: 100%;\r\n  height: 36px;\r\n  padding: 0 12px 0 36px;\r\n  box-sizing: border-box;\r\n  border: none;\r\n  border-radius: 9px;\r\n  background: transparent;\r\n  color: rgba(255, 255, 255, 0.82);\r\n  font-family: inherit;\r\n  font-size: 13.5px;\r\n  font-weight: 500;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: color 0.15s ease;\r\n}\r\n\r\n/* Hover fill for a non-active sub-item — same footprint as the sliding\r\n   active pill (left/right/top/height/radius below mirror .app-nav-active-bg)\r\n   filled with the shared hover colour, so it matches the parent rows and the\r\n   header selectors. Sits behind the icon/label via z-index: -1. */\r\n.app-nav-subitem::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 28px;\r\n  right: 8px;\r\n  top: 2px;\r\n  height: 32px;\r\n  border-radius: 9px;\r\n  background-color: var(--sidebar-hover-bg);\r\n  opacity: 0;\r\n  transition: opacity 0.15s ease;\r\n  pointer-events: none;\r\n  z-index: -1;\r\n}\r\n\r\n.app-nav-subitem:hover:not(.selected) {\r\n  color: #ffffff;\r\n}\r\n.app-nav-subitem:hover:not(.selected)::before {\r\n  opacity: 1;\r\n}\r\n\r\n.app-nav-subitem.selected {\r\n  color: #2c1769;\r\n  font-weight: 600;\r\n}\r\n\r\n.app-nav-subicon {\r\n  width: 18px;\r\n  font-size: 14px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  color: rgba(255, 255, 255, 0.7);\r\n  transition: color 0.15s ease;\r\n}\r\n.app-nav-subitem.selected .app-nav-subicon {\r\n  color: #5616ea;\r\n}\r\n\r\n/* Single-colour brand artwork (the black Wix wordmark) sitting in a nav row.\r\n   The sidebar is dark purple and the hover fill only lifts it 7%, so the mark is\r\n   knocked out to white for both of those states; `selected` swaps the row to a\r\n   white pill, where the original artwork is the readable one. brightness(0)\r\n   first flattens any anti-aliasing to black so invert() yields a clean white\r\n   rather than a washed grey. Multi-colour logos (Drive, OneDrive, Notion,\r\n   Shopify) must NOT carry this class: their brand colours read fine on both. */\r\n.app-nav-subicon .nav-logo-mono {\r\n  filter: brightness(0) invert(1);\r\n  transition: filter 0.15s ease;\r\n}\r\n.app-nav-subitem.selected .app-nav-subicon .nav-logo-mono {\r\n  filter: none;\r\n}\r\n\r\n/* Becoming active, the row turns purple at once. A colour transition runs on the main thread: while\r\n   the next page was still building it stalled, but the white pill (a transform, animated off the main\r\n   thread) had already arrived, so icon and label stayed white on white for up to a second. */\r\n.app-nav-subitem.selected,\r\n.app-nav-subitem.selected .app-nav-subicon,\r\n.app-nav-subitem.selected .app-nav-subicon .nav-logo-mono {\r\n  transition: none;\r\n}\r\n\r\n/* Unread-leads badge (Activity group header + Leads leaf). Default sits on the\r\n   purple sidebar: white pill, purple number. */\r\n.app-nav-badge {\r\n  flex: 0 0 auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 19px;\r\n  height: 19px;\r\n  padding: 0 6px;\r\n  border-radius: 999px;\r\n  background: #ffffff;\r\n  color: #5616ea;\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n}\r\n/* The selected leaf sits on a white pill, so invert the badge (purple fill,\r\n   white number) to keep it readable and consistent with the unselected look. */\r\n.app-nav-subitem.selected .app-nav-badge {\r\n  background: #5616ea;\r\n  color: #ffffff;\r\n}\r\n\r\n/* ── Bottom block ──────────────────────────────────────────────────── */\r\n.app-sidebar-bottom {\r\n  flex: 0 0 auto;\r\n  padding: 8px 10px 14px;\r\n}\r\n\r\n/* \"+ New Agent\" — primary action on the account-level nav. White pill on the\r\n   purple sidebar so it reads as the main CTA, echoing the selected-row pill. */\r\n.app-sidebar-new-agent {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  padding: 10px 12px;\r\n  border: none;\r\n  border-radius: 10px;\r\n  background: #ffffff;\r\n  color: #5616ea;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  font-size: 15.5px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease, transform 0.05s ease;\r\n}\r\n.app-sidebar-new-agent:hover {\r\n  background: #f1ecfe;\r\n}\r\n.app-sidebar-new-agent:active {\r\n  transform: translateY(1px);\r\n}\r\n\r\n.app-sidebar-footer-links {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 22px 12px 0;\r\n}\r\n.app-sidebar-footer-links a {\r\n  color: rgba(255, 255, 255, 0.7);\r\n  font-size: 11px;\r\n  text-decoration: none;\r\n}\r\n.app-sidebar-footer-links a:hover {\r\n  color: #fff;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* ── Responsive: slide-over on mobile ──────────────────────────────── */\r\n@media (max-width: 768px) {\r\n  .app-sidebar {\r\n    transform: translateX(-100%);\r\n    /* No shadow while collapsed: the panel sits at translateX(-100%) with its\r\n       right edge on the screen's left edge, so a right-cast shadow bleeds onto\r\n       the page. Only show it once the drawer is open. */\r\n    box-shadow: none;\r\n  }\r\n  .app-sidebar.app-sidebar--open {\r\n    transform: translateX(0);\r\n    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.35);\r\n  }\r\n}\r\n\r\n/* ── Mobile-only docked controls (workspace + bot selectors + Test Agent) ──\r\n   On phones these move out of the header and sit at the top of the sidebar,\r\n   above a hairline divider and the nav. Only rendered when isMobile, so no\r\n   media query is needed here. */\r\n.app-sidebar-mobile-top {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  padding: 12px 12px 14px;\r\n  /* Divider underneath the docked controls (replaces a separate hairline div). */\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n/* Full-width translucent pills: white-on-translucent, borderless, space-between. */\r\n.app-sidebar-mobile-top .org-switcher,\r\n.app-sidebar-mobile-top .bot-selector {\r\n  width: 100%;\r\n  margin: 0;\r\n  padding-right: 0;\r\n}\r\n.app-sidebar-mobile-top .org-switcher-trigger,\r\n.app-sidebar-mobile-top .bot-selector-trigger {\r\n  width: 100%;\r\n  margin: 0;\r\n  justify-content: space-between;\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n  border: none;\r\n  border-radius: 8px;\r\n}\r\n.app-sidebar-mobile-top .org-switcher-trigger:hover,\r\n.app-sidebar-mobile-top .org-switcher-trigger:focus-within,\r\n.app-sidebar-mobile-top .org-switcher-trigger.open,\r\n.app-sidebar-mobile-top .bot-selector-trigger:hover,\r\n.app-sidebar-mobile-top .bot-selector-trigger:focus-within,\r\n.app-sidebar-mobile-top .bot-selector-trigger.open {\r\n  background-color: rgba(255, 255, 255, 0.16);\r\n  border: none;\r\n}\r\n.app-sidebar-mobile-top .org-switcher-menu,\r\n.app-sidebar-mobile-top .bot-selector-menu {\r\n  left: 0;\r\n  right: 0;\r\n}\r\n/* Compact single line: drop the \"Current Workspace\" / \"Current agent\" roles,\r\n   small leading icon, 13px bold name, small chevron. */\r\n.app-sidebar-mobile-top .org-switcher-role,\r\n.app-sidebar-mobile-top .bot-selector-role {\r\n  display: none;\r\n}\r\n.app-sidebar-mobile-top .org-switcher-icon,\r\n.app-sidebar-mobile-top .bot-selector-icon {\r\n  width: auto;\r\n  height: auto;\r\n  font-size: 15px;\r\n  flex: 0 0 auto;\r\n}\r\n.app-sidebar-mobile-top .org-switcher-label,\r\n.app-sidebar-mobile-top .bot-selector-label {\r\n  gap: 8px;\r\n  padding: 7px 4px 7px 10px;\r\n}\r\n.app-sidebar-mobile-top .org-switcher-name,\r\n.app-sidebar-mobile-top .bot-selector-name {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n}\r\n.app-sidebar-mobile-top .org-switcher-chev-btn,\r\n.app-sidebar-mobile-top .bot-selector-chev-btn {\r\n  padding: 7px 10px 7px 4px;\r\n}\r\n.app-sidebar-mobile-top .org-switcher-chev,\r\n.app-sidebar-mobile-top .bot-selector-chev {\r\n  font-size: 18px;\r\n}\r\n/* Test Agent: full-width white CTA under the switchers. Padding + font match\r\n   the selector pills (7px label padding, 13px text; the button's 1px border\r\n   makes up the extra 1px) so all three sit at the same height. */\r\n.app-sidebar-mobile-top .app-header-test-btn {\r\n  width: 100%;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  padding: 6px 12px;\r\n  font-size: 13px;\r\n}\r\n.app-sidebar-mobile-top .app-header-test-btn span {\r\n  display: inline-flex;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
